module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_v_hazel.8ad98bba.png";